export enum BulkOperationTypeEnum {
  Create,
  Update,
  Delete,
}
